import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MapIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MapIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M2.75182 19.9961C2.60546 19.9961 2.46009 19.9535 2.33479 19.8698C2.12578 19.7303 2 19.4959 2 19.2443V7.32487C2 7.02141 2.18257 6.7478 2.46255 6.63082L8.62784 4.06162C8.86033 3.96519 9.12513 3.99064 9.33414 4.13014C9.54314 4.26964 9.66893 4.5041 9.66893 4.75567V16.6756C9.66893 16.9791 9.48635 17.2527 9.20638 17.3697L3.04109 19.9384C2.94809 19.977 2.8497 19.9961 2.75182 19.9961ZM3.50363 7.82608V18.1166L8.16529 16.1744V5.8834L3.50363 7.82608Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.0824 19.9961C14.9845 19.9961 14.8861 19.977 14.7931 19.9384L8.62784 17.3697C8.34786 17.2527 8.16529 16.9791 8.16529 16.6756V4.75567C8.16529 4.50409 8.29109 4.26964 8.50008 4.13014C8.70908 3.99064 8.97389 3.96519 9.20638 4.06162L15.3717 6.63082C15.6516 6.7478 15.8342 7.02141 15.8342 7.32487V19.2443C15.8342 19.4959 15.7084 19.7303 15.4994 19.8698C15.3741 19.9535 15.2288 19.9961 15.0824 19.9961ZM9.66893 16.1744L14.3306 18.1166V7.82608L9.66893 5.8834V16.1744Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.0824 19.9961C14.936 19.9961 14.7907 19.9535 14.6654 19.8698C14.4564 19.7303 14.3306 19.4959 14.3306 19.2443V7.32487C14.3306 7.02141 14.5132 6.7478 14.7931 6.63082L20.9589 4.06162C21.1909 3.96519 21.4562 3.99064 21.6652 4.13014C21.8742 4.26964 22 4.5041 22 4.75567V16.6756C22 16.9791 21.8174 17.2527 21.5375 17.3697L15.3717 19.9384C15.2787 19.977 15.1803 19.9961 15.0824 19.9961ZM15.8342 7.82608V18.1166L20.4964 16.1744V5.8834L15.8342 7.82608Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MapIcon;
